import React, { useState } from "react";
import { useNavigate,useHistory  } from "react-router-dom";
import { generatePath } from "react-router";
import {apiUrl, domainUrl} from '../constant';
import {authtoken} from '../global.js';
import {authHeader,authToken} from '../helpers/auth-header';
import axios from 'axios';
const axios1 = require("axios");
export const timesheetuserService = {
    getusers,
    searchusers,
    getuserlistbyapprover,
    getdept,
    getrole,
    getteam,
    getproject,
    getApprover,
    getcostcenter,
    addUser,
    bulkuploadusersnew,
    updateusr,
    getdepartments,
    updatesubclientadjust,
    getalluserslist,
    addtaget_hours,
    resetpass,
    updateuserstatus,
    adduserassign,
    addnewadjustmentdata,
    deletetarget,
};

function getusers(pageno){
    return axios({
        method: "get",
        url: `${apiUrl}/api/getusers?page=${pageno}`,
        // data: requestQuery,
        headers: {Authorization: `Bearer ${authToken()}` },
      })
        .then(function (response) {
           if(response.status == 200){
                    
          }
          return response;
        }, error => {
          return error.response;
          // console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });   
}

function searchusers({searchq, pageno}){
  return axios({
      method: "get",
      url: `${apiUrl}/api/searchusers?search=${searchq}&page=${pageno || 1}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });   
}

function getuserlistbyapprover(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getuserlist?date=2024-01-01`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function getdept(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getdeptname`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getrole(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getroles`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getteam(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getteamname`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function getproject(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getprojects`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function getcostcenter(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getcostcenter`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function getApprover(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getApprover`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function bulkuploadusersnew({file_data}){
  return axios({
    method: "post",
    url: `${apiUrl}/api/bulkuploadusersnew`,
    data: { file_data },
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error);
      return error;
    });
}

function addUser({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/signup/client`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    }); 
}

function updateusr({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/updateusr`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });  
}

function updateuserstatus({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/updateuserstatus`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    }); 
}

function getdepartments({userid= ''}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getdepartments?userid=${userid}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function updatesubclientadjust({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/updatesubclientadjust`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    }); 
}

function getalluserslist(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getalluserslist`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function addtaget_hours({formobj}){
  let requestQuery = formobj; 
  return axios({
    method: "post",
    url: `${apiUrl}/api/addtaget_hours`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function deletetarget(id){
  let id_ = id; 
  return axios({
    method: "get",
    url: `${apiUrl}/api/deletetarget?id=${id_}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}



function resetpass({userid}){
  return axios({
    method: "post",
    url: `${apiUrl}/api/resetpass`,
    data: {'id':userid},
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      if(response.status == 200){
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function adduserassign({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/adduserassign`,
    data: obj,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      if(response.status == 200){
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function addnewadjustmentdata(obj){
  return axios({
    method: "post",
    url: `${apiUrl}/api/addnewadjustmentdata`,
    data: obj,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      if(response.status == 200){
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

